// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SelectFixedItemsDataQueryVariables = Types.Exact<{
  projectStageId: Types.Scalars['ID']['input'];
}>;


export type SelectFixedItemsDataQuery = { __typename?: 'Query', projectStage: { __typename?: 'ProjectStage', id: string, homeownerContracts: Array<{ __typename?: 'HomeownerContract', id: string, lineItemsByProjectItem: Array<{ __typename?: 'HomeownerContractLineItemsByProjectItem', lineItems: Array<{ __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, budgetChangeInCents?: number | null | undefined, owner:
            | { __typename?: 'HomeownerContract', id: string, name: string, contractType: Types.ContractType }
            | { __typename?: 'HomeownerContractChangeOrder', id: string, name: string, contractType: Types.ContractType, contract: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType } }
          , projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType } } }, bills: Array<{ __typename?: 'Bill', id: string }> }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, amountInCents: number }> }> }> }> } };

export type SelectFixedItemsHomeownerContractsFragment = { __typename?: 'HomeownerContract', id: string, lineItemsByProjectItem: Array<{ __typename?: 'HomeownerContractLineItemsByProjectItem', lineItems: Array<{ __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, budgetChangeInCents?: number | null | undefined, owner:
        | { __typename?: 'HomeownerContract', id: string, name: string, contractType: Types.ContractType }
        | { __typename?: 'HomeownerContractChangeOrder', id: string, name: string, contractType: Types.ContractType, contract: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType } }
      , projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType } } }, bills: Array<{ __typename?: 'Bill', id: string }> }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, amountInCents: number }> }> }> };

export type SelectFixedItemsHomeownerContractLineItemFragment = { __typename?: 'HomeownerContractLineItem', id: string, priceChangeInCents?: number | null | undefined, budgetChangeInCents?: number | null | undefined, owner:
    | { __typename?: 'HomeownerContract', id: string, name: string, contractType: Types.ContractType }
    | { __typename?: 'HomeownerContractChangeOrder', id: string, name: string, contractType: Types.ContractType, contract: { __typename?: 'HomeownerContract', id: string, contractType: Types.ContractType } }
  , projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType } } }, bills: Array<{ __typename?: 'Bill', id: string }> }, invoiceLineItems: Array<{ __typename?: 'InvoiceLineItem', id: string, amountInCents: number }> };

export type SelectFixedItemsProjectItemFragment = { __typename?: 'ProjectItem', id: string, displayName: string, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, costClassification: { __typename?: 'CostClassificationTypeDetail', code: Types.CostClassificationType } } }, bills: Array<{ __typename?: 'Bill', id: string }> };

export const SelectFixedItemsProjectItemFragmentDoc = gql`
    fragment SelectFixedItemsProjectItem on ProjectItem {
  id
  displayName
  item {
    id
    costCode {
      id
      displayName
      costClassification {
        code
      }
    }
  }
  bills {
    id
  }
}
    `;
export const SelectFixedItemsHomeownerContractLineItemFragmentDoc = gql`
    fragment SelectFixedItemsHomeownerContractLineItem on HomeownerContractLineItem {
  id
  owner {
    id
    name
    contractType
    ... on HomeownerContractChangeOrder {
      id
      contract {
        id
        contractType
      }
    }
  }
  priceChangeInCents
  budgetChangeInCents
  projectItem {
    ...SelectFixedItemsProjectItem
  }
  invoiceLineItems {
    id
    amountInCents
  }
}
    ${SelectFixedItemsProjectItemFragmentDoc}`;
export const SelectFixedItemsHomeownerContractsFragmentDoc = gql`
    fragment SelectFixedItemsHomeownerContracts on HomeownerContract {
  id
  lineItemsByProjectItem {
    lineItems {
      ...SelectFixedItemsHomeownerContractLineItem
    }
  }
}
    ${SelectFixedItemsHomeownerContractLineItemFragmentDoc}`;
export const SelectFixedItemsDataDocument = gql`
    query SelectFixedItemsData($projectStageId: ID!) {
  projectStage(id: $projectStageId) {
    id
    homeownerContracts {
      ...SelectFixedItemsHomeownerContracts
    }
  }
}
    ${SelectFixedItemsHomeownerContractsFragmentDoc}`;

/**
 * __useSelectFixedItemsDataQuery__
 *
 * To run a query within a React component, call `useSelectFixedItemsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectFixedItemsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectFixedItemsDataQuery({
 *   variables: {
 *      projectStageId: // value for 'projectStageId'
 *   },
 * });
 */
export function useSelectFixedItemsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables> & ({ variables: SelectFixedItemsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>(SelectFixedItemsDataDocument, options);
      }
export function useSelectFixedItemsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>(SelectFixedItemsDataDocument, options);
        }
// @ts-ignore
export function useSelectFixedItemsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>;
export function useSelectFixedItemsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SelectFixedItemsDataQuery | undefined, SelectFixedItemsDataQueryVariables>;
export function useSelectFixedItemsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>(SelectFixedItemsDataDocument, options);
        }
export type SelectFixedItemsDataQueryHookResult = ReturnType<typeof useSelectFixedItemsDataQuery>;
export type SelectFixedItemsDataLazyQueryHookResult = ReturnType<typeof useSelectFixedItemsDataLazyQuery>;
export type SelectFixedItemsDataSuspenseQueryHookResult = ReturnType<typeof useSelectFixedItemsDataSuspenseQuery>;
export type SelectFixedItemsDataQueryResult = ApolloReactCommon.QueryResult<SelectFixedItemsDataQuery, SelectFixedItemsDataQueryVariables>;